import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import ButtonLoader from "../components/ButtonLoader";
import { Helmet } from "react-helmet";
import SignagePlayer from "../components/SignagePlayer";
import { Result } from "antd";
import { WarningOutlined } from "@ant-design/icons";

const Play = () => {
  const { slug } = useParams();

  const navigate = useNavigate();
  const [playData, setPlayData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [playlist, setPlaylist] = useState([]);
  const [showError, setShowError] = useState(false);
  const [pageTitle, setPageTitle] = useState("");

  const playlistRef = useRef([]); // For comparing current playlist

  useEffect(() => {
    if (
      localStorage.getItem("playtoken") === null ||
      localStorage.getItem("playtoken") === ""
    ) {
      navigate(`/otp/${slug}`, { replace: true });
    }
  }, [slug, navigate]);

  const fetchData = async (slug, isInterval = false) => {
    try {
      const playToken = localStorage.getItem("playtoken");
      const customAxios = axios.create();
      const response = await customAxios.get(
        `${process.env.REACT_APP_BASE_URL}/api/play/${slug}`,
        {
          headers: {
            Authorization: "Bearer " + playToken,
          },
        }
      );
      let record = response.data.data;

      // Only update if playlist has changed
      const newPlaylist = record.media_data;
      if (
        !isInterval || // First load: always set state
        JSON.stringify(newPlaylist) !== JSON.stringify(playlistRef.current)
      ) {
        playlistRef.current = newPlaylist;
        setPlaylist(newPlaylist);
        setPageTitle(process.env.REACT_APP_NAME + " | " + record.name);
        setPlayData(record);
        setShowError(false);
        setLoading(false);
        console.log("Playlist updated");
      } else {
        console.log("Playlist unchanged");
      }
    } catch (err) {
      console.error(err);
      if (err?.response?.status === 401) {
        localStorage.removeItem("playtoken");
        navigate(`/otp/${slug}`, { replace: true });
      }
      if (err?.response?.status === 404) {
        setShowError(true);
        setPageTitle(process.env.REACT_APP_NAME + " | Page not found");
      }
      if (!isInterval) setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(slug);

    const intervalId = setInterval(() => {
      fetchData(slug, true);
    }, 60 * 1000); // every 1 minute

    return () => clearInterval(intervalId);
  }, [slug]);

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>
      {loading ? (
        <ButtonLoader wrapperClass={`vh-100`} />
      ) : (
        <>
          {showError && (
            <div className="d-flex justify-content-center align-items-center vh-100 text-white bg-black">
              <Result
                icon={<WarningOutlined style={{ fontSize: 72 }} />}
                title="404"
                subTitle="Sorry, the page you visited does not exist."
              />
            </div>
          )}
          {!showError && playData && playlist.length > 0 && (
            <>
              <SignagePlayer playlist={playlist} />
            </>
          )}
        </>
      )}
    </>
  );
};

export default Play;
